export default __webpack_public_path__ + "static/media/Oracle.995c90d9.png";